import keyMirror from 'keymirror';
import { nameInUrlFormat, withLanguageLocale } from '../../services/Helper';

export const examDetailsActionTypes = keyMirror({
	GET_EXAM_DETAILS: null,
	GET_EXAM_DETAILS_SUCCESS: null,
	GET_EXAM_DETAILS_ERROR: null,
	CLEAN_EXAM_DETAILS_STATE: null,
});

export const getExamDetailsTabs = (id, type, name, t) => [
	{
		title: t('exam_details.tabs.details'),
		value: '',
		link: withLanguageLocale(`/exams/${type}/${id}/${nameInUrlFormat(name)}`),
		index: 0,
	},
	{
		title: t('exam_details.tabs.results'),
		value: 'results',
		link: withLanguageLocale(`/exams/${type}/${id}/${nameInUrlFormat(name)}/results`),
		index: 1,
	},
];

export const EXAM_PROGRESS_STATES = {
	start: 'start',
	in_progress: 'in_progress',
	done: 'done',
};

export const EXAM_TYPES = {
	full: 'full_exam',
	set: 'exam_practice_set',
};

export const EXAM_REQUEST_TYPES = {
	full: 'full_exams',
	set: 'exam_practice_sets',
};

export const EXAM_TYPE_IDS = {
	full: 'full_exam_id',
	set: 'exam_practice_set_id',
};
